import axios, { AxiosRequestConfig } from 'axios';
import { getOdataRootUrl } from '@bingads-webui-react/copilot-utils';
import { formatTodayGridDate } from './utils';
import type { AccountRouteProps, AuthorizedRequestProps, ODataQueryParams } from './types';

export const MAXIMUM_CAMPAIGN_COUNT_UNDER_CAMPAIGN = '500';

// TODO: Implement fetchAdGroupData function and props
export interface IFetchCampaignsUrlProps extends AccountRouteProps {
  params?: ODataQueryParams;
}

const CampaignOdataConfig = {
  $expand: 'AssociatedExperiment,Budget,Labels,RSAAdCustomizerAttributes',
  $top: MAXIMUM_CAMPAIGN_COUNT_UNDER_CAMPAIGN,
  $count: 'true',
  $orderby: 'Status asc',
  $select: 'AvailableInsightTypeIds,BaseCampaignName,BidStrategyName,BiddingScheme,CampaignDeliveryStatusDetails,CampaignMigrationStatus,CampaignSubType,CampaignType,DeliveryStatus,DeliveryStatusDetails,ExperimentId,Id,IsBidLandscapeAvailable,Name,OptimizationScore,PerformanceMetrics/AbsoluteTopImpressionRate,PerformanceMetrics/AverageCPC,PerformanceMetrics/CTR,PerformanceMetrics/Clicks,PerformanceMetrics/ConversionsCredit,PerformanceMetrics/Impressions,PerformanceMetrics/Spend,PerformanceMetrics/TopImpressionRate,PerformanceMetrics/ViewThroughConversionsCredit,Status',
};

export interface IFetchCampaignsGridDataProps extends IFetchCampaignsUrlProps, AuthorizedRequestProps {}

export function getFetchCampaignGridUrl({
  customerId,
  accountId,
  params = CampaignOdataConfig,
}: IFetchCampaignsUrlProps) {
  const queryString = new URLSearchParams(params);

  return `${getOdataRootUrl()}/ODataApi/Campaign/V2/Customers(${customerId})/Accounts(${accountId})/Campaigns/Default.GridData?${queryString}`;
}

export function fetchAllCampaignsData({
  accountId,
  customerId,
  ccToken,
}: IFetchCampaignsGridDataProps) {
  const url = getFetchCampaignGridUrl({ customerId, accountId });

  const postDataParams = {
    gridDataParameters: {
      DateRange: {
        StartDate: formatTodayGridDate(),
        EndDate: formatTodayGridDate(),
      },
      CurrentCustomerId: customerId,
    },
  };

  return axios.post(
    url,
    {
      ...postDataParams,
    },
    {
      headers: {
        Authorization: ccToken,
        'content-type': 'application/json',
      },

    } as AxiosRequestConfig
  );
}
